import { render, staticRenderFns } from "./BeAgentPopup.vue?vue&type=template&id=861a44b2"
import script from "./BeAgentPopup.vue?vue&type=script&lang=js"
export * from "./BeAgentPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/vercel/path0/components/common/Modal.vue').default})
